function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".data-encrypt_svg__d,.data-encrypt_svg__e{fill:#fff}.data-encrypt_svg__c,.data-encrypt_svg__f{fill:none}.data-encrypt_svg__c,.data-encrypt_svg__e{stroke:#2196f3}.data-encrypt_svg__c{stroke-linecap:round}.data-encrypt_svg__c,.data-encrypt_svg__e,.data-encrypt_svg__f{stroke-width:2px}.data-encrypt_svg__f{stroke:#1d1f2c}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-102.999 -22)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M111.739 90.074a22.994 22.994 0 010-32.525l27.578-27.578a23 23 0 0132.525 32.531l-27.578 27.572a22.994 22.994 0 01-32.525 0z",
  fill: "#2196f3",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  className: "data-encrypt_svg__c",
  d: "M141 71.754V60M121 75v-6.246A1.731 1.731 0 01122.707 67H127M131 59v6.246A1.731 1.731 0 01129.293 67H125M161 75v-6.246A1.731 1.731 0 00159.293 67H155M151 59v6.246A1.731 1.731 0 00152.707 67H157"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__d",
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  transform: "translate(115 72)"
}), /*#__PURE__*/React.createElement("path", {
  className: "data-encrypt_svg__e",
  d: "M122.498 86.998a7.417 7.417 0 01-4.365-1.406 4.5 4.5 0 118.732 0 7.424 7.424 0 01-4.367 1.406z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__e",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(120 75)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__f",
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  transform: "translate(115 72)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(19)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__d",
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  transform: "translate(115 72)"
}), /*#__PURE__*/React.createElement("path", {
  className: "data-encrypt_svg__e",
  d: "M122.498 86.998a7.417 7.417 0 01-4.365-1.406 4.5 4.5 0 118.732 0 7.424 7.424 0 01-4.367 1.406z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__e",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(120 75)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__f",
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  transform: "translate(115 72)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(39)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__d",
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  transform: "translate(115 72)"
}), /*#__PURE__*/React.createElement("path", {
  className: "data-encrypt_svg__e",
  d: "M122.498 86.998a7.417 7.417 0 01-4.365-1.406 4.5 4.5 0 118.732 0 7.424 7.424 0 01-4.367 1.406z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__e",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(120 75)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "data-encrypt_svg__f",
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  transform: "translate(115 72)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M128 61v-.018A7.5 7.5 0 01128.5 46c.17 0 .338.006.506.018a11.5 11.5 0 0121.023-5.953 6.925 6.925 0 01.971-.068 7 7 0 016.3 10.063 5.5 5.5 0 01-.3 10.918v.023z",
  strokeLinejoin: "round",
  stroke: "#1d1f2c",
  strokeWidth: 2,
  strokeLinecap: "round",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  className: "data-encrypt_svg__e",
  width: 8,
  height: 14,
  rx: 4,
  transform: "translate(137 42)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(134 47)",
  strokeLinejoin: "round",
  strokeWidth: 2,
  strokeLinecap: "round",
  stroke: "#2196f3",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 10,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 12,
  height: 8,
  rx: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  className: "data-encrypt_svg__c",
  d: "M141 52.734V51"
}));

var SvgDataEncrypt = function SvgDataEncrypt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgDataEncrypt as ReactComponent };